/**
 *
 * NpgFeMerchantPortal
 *
 */
import React from 'react'
import PropTypes from 'prop-types'
import { Routes } from 'react-router-dom'
import Box from '@mui/material/Box'
import { connect } from 'react-redux'
import { permittedRoutes } from 'Utility/globalMethods'
import { userPermissions, userProfileInfo } from 'Store/selectors'
import flowPopupMap from '../schemas/flowPopupMap'
import 'Style/scss/main.scss'

const mapStateToProps = (state) => ({
  flowPopupId: state.popup.flowPopup,
  suspendedFlowPopupId: state.popup.suspendedFlowPopup,
  userPermissions: userPermissions(state),
  userInfo: userProfileInfo(state)
})

export const NpgFeMerchantPortalContainer = ({
  authRoutes,
  unauthRoutes,
  logged,
  flowPopupId,
  suspendedFlowPopupId,
  userPermissions,
  userInfo
}) => {
  const loggedApp = authRoutes.routes.map(({ component }) => component())
  // Only the session-extension popup is allowed to temporarily overlay an existing popup.
  const isSessionExtensionOverlay = flowPopupId === 'EXTEND_SESSION' && Boolean(suspendedFlowPopupId)
  // Keep the original popup in the first render slot so React preserves its local state.
  const basePopup = flowPopupMap[isSessionExtensionOverlay ? suspendedFlowPopupId : flowPopupId]
  // Render the session warning in a second slot, above the preserved popup.
  const sessionExtensionPopup = isSessionExtensionOverlay ? flowPopupMap[flowPopupId] : ''

  return (
    <>
      <Box className='main'>
        <Routes>
          {unauthRoutes.routes.map(({ component }) => component())}
          {logged && permittedRoutes(loggedApp, userPermissions, userInfo)}
        </Routes>
        {basePopup}
        {sessionExtensionPopup}
      </Box>
    </>
  )
}

NpgFeMerchantPortalContainer.propTypes = {
  authRoutes: PropTypes.objectOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        component: PropTypes.func.isRequired
      })
    )
  ).isRequired,
  unauthRoutes: PropTypes.objectOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        component: PropTypes.func.isRequired
      })
    )
  ).isRequired,
  logged: PropTypes.bool.isRequired,
  flowPopupId: PropTypes.string,
  suspendedFlowPopupId: PropTypes.string,
  userPermissions: PropTypes.array,
  userInfo: PropTypes.object
}

export default connect(mapStateToProps)(NpgFeMerchantPortalContainer)
